import React, { JSXElementConstructor } from 'react'
import { styled } from '@mui/material/styles'
import { css } from '@emotion/react'
import ReactPerfectScrollbar from 'react-perfect-scrollbar'
import { List, SvgIconTypeMap } from '@mui/material'
import { Theme, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import SidebarNavSection from './SidebarNavSection'

import '../../vendor/perfect-scrollbar.css'
import { LucideIcon } from 'lucide-react'
import { Icon } from 'react-feather'
import { OverridableComponent } from '@mui/material/OverridableComponent'

const baseScrollbar = ({ theme }: { theme: Theme }) => css`
    background-color: ${theme.sidebar.background};
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    flex-grow: 1;
`

const Scrollbar = styled('div')`
    ${baseScrollbar}
`

const PerfectScrollbar = styled(ReactPerfectScrollbar)`
    ${baseScrollbar}
`

const Items = styled('div')`
    padding-top: ${({ theme }) => theme.spacing(2.5)};
    padding-bottom: ${({ theme }) => theme.spacing(2.5)};
`

export interface SidebarNavProps {
    items: Array<{
        title: string
        pages: Array<{
            icon: LucideIcon | Icon | OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
            badge?: JSXElementConstructor<'div'>
            href: string
            disabled?: boolean
            title: string
            children?: Array<{
                icon: LucideIcon | Icon | OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
                href: string
                title: string
            }>
        }>
        disabled?: boolean
    }>
}

const SidebarNav = ({ items }: SidebarNavProps) => {
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('md'))
    const ScrollbarComponent = matches ? PerfectScrollbar : Scrollbar

    const navItems = items.map((item) => {
        if (matches) return item
        const itemPages = item.pages.filter((page) => !page.href.includes('/calendar'))

        return { ...item, pages: itemPages }
    })

    return (
        <ScrollbarComponent>
            <List disablePadding>
                <Items>
                    {navItems &&
                        navItems.map((item) => (
                            <SidebarNavSection
                                component='div'
                                key={item.title}
                                pages={item.pages}
                                title={item.title}
                                disabled={item.disabled}
                            />
                        ))}
                </Items>
            </List>
        </ScrollbarComponent>
    )
}

export default SidebarNav
